export default __webpack_public_path__ + "static/cafeterabg1_5-d9d507ac9d45e18e11d4812fb92becb0.png";